"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleNetworkError = void 0;
var types_1 = require("../networking/types");
var handleNetworkError = function (error, cb) {
    if (error.message !== types_1.Message.NetworkError)
        cb();
};
exports.handleNetworkError = handleNetworkError;
